<div class="attribute-card" [ngClass]="{ 'show-empty': showEmpty }" *ngFor="let customField of customFields">
  <profile-custom-field-editor
    [customFieldValues]="getCustomFieldValueByTypeId(customField.id)"
    [customField]="customField"
    [seat]="seat"
    [id]="customField.id"
    [ngClass]="{ 'is-empty': isEmpty(customField) }"
  ></profile-custom-field-editor>
</div>
